import { createSelector } from 'reselect';

const pageData = window.pageData;
const templateType = window.templateType;

export const templateTypeSelector = createSelector(
    () => templateType
);

export const isDashboardSelector = createSelector(
    () => templateType === 'dashboard'
);

export const currentCompanyNameSelector = createSelector(
    () => pageData.currentUsercompanyName
);

export const availableSearchTabsSelector = state => state.pageStatus.searchResultsExist;
